/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP Management 개발
 *
 ********************************************************************/
import React, { useState } from "react";
//recoil
import { useRecoilValue } from "recoil";
import { loadingBoxState, } from '../../recoil/menuState';
// utils
import clog from "../../utils/logUtils";
import * as CONST from "../../utils/Const";
import * as CUTIL from "../../utils/commUtils";
//component
import UserMain from "./user/UserMain";
import ApprovalMain from "./approval/ApprovalMain";
import SiteMain from "./site/SiteMain";
import MenuMain from "./menu/MenuMain";
import MassageMain from "./massage/MessageMain";
import CheckSheetMain from "./checksheet/CheckSheetMain";
import EconsultMain from "./econsult/EconsultMain";
/**
 * @brief EHP Management 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ManagementMain(props) {
    //recoil
    const isLoadingBox = useRecoilValue(loadingBoxState);
    //props
    const tabMenuList = props.tabMenuList;
    const curTabMenu = props.curTabMenu;
    const setParentCurTabMenu = props.setCurTabMenu;
    const setParentPopWin = props.setPopWin;
    // option 선택 시  값 변경 액션
    function selectTabOption(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        clog("OPT VAL : " + optionElement.value);
        setParentCurTabMenu(JSON.parse(optionData)); // 탭 또는 모바일 경우
        //resetSearchParams();
    }
    function onClickTab(e) {
        var actTag = (e.target.tagName === "DIV") ? e.target : e.currentTarget;
        var tabStrInfo = actTag.getAttribute("data-value");
        var tabInfo = JSON.parse(tabStrInfo);
        //clog("TAB : " + JSON.stringify(tabInfo));
        //setAdminType(tabInfo.adminType);
        setParentCurTabMenu(tabInfo);
        setParentPopWin("pop-message-add", null);
        setParentPopWin("pop-message", null);
        setParentPopWin("pop-delete", null);
        setParentPopWin("pop-message-edit", null);
        //
        setParentPopWin("pop-answer-ok", null);
        setParentPopWin("pop-answer", null);
    }
    const [isNodata, setIsNoData] = useState(false);
    function handleNodata(pageInfo) {
        if (pageInfo.totalElements <= 0) {
            setIsNoData(true);
        }
        else {
            setIsNoData(false);
        }
    }
    //clog("IN MANAGEMENTMAIN : INIT : ISLOADING CHECK : " + isLoadingBox);
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: `container admin-site ${(curTabMenu.tabUrl === CONST.URL_ECONSULTMANAGEMENT) ? "" : "layout-w3"} ${(curTabMenu.tabUrl === CONST.URL_SITEMANAGEMENT) ? "rightcont-half" : ""}`, style: { "cursor": "default" } },
            " ",
            React.createElement("section", { className: "content" },
                React.createElement("article", { className: `box list ${(isLoadingBox) ? "loading__box" : ""}` },
                    React.createElement("div", { className: `box__body ${(isNodata) ? "nodata" : ""}` },
                        React.createElement("section", { className: "swiper-section" },
                            React.createElement("div", { className: "swiper-container mySwiper ", style: { "cursor": "pointer" } },
                                React.createElement("div", { className: "swiper-wrapper" }, tabMenuList.map((tabMenu, idx) => (React.createElement("div", { key: `tab_${idx.toString()}`, className: `swiper-slide tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, onClick: (e) => onClickTab(e), "data-value": JSON.stringify(tabMenu) },
                                    React.createElement("p", null, tabMenu.tabName))))))),
                        React.createElement("div", { className: "d-sm-tab" },
                            React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectTabOption) },
                                React.createElement("div", { className: "selected" },
                                    React.createElement("div", { className: "selected-value" }, curTabMenu.tabName),
                                    React.createElement("div", { className: "arrow" })),
                                React.createElement("ul", null, tabMenuList.map((tabMenu, idx) => (React.createElement("li", { key: `tab_m_${idx.toString()}`, className: `option tab ${(tabMenu.tabId === curTabMenu.tabId) ? "on" : ""}`, "data-value": JSON.stringify(tabMenu) }, tabMenu.tabName)))))),
                        (curTabMenu.tabUrl === CONST.URL_APPROVALMANAGEMENT /*"TAB_APPROVAL"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent current" },
                                React.createElement(ApprovalMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_USERMANAGEMENT /*"TAB_USER"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent layout-w2 current" },
                                React.createElement(UserMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_SITEMANAGEMENT /*"TAB_SITE"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent layout-w2 current" },
                                React.createElement(SiteMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_MESSAGEMANAGEMENT /*"TAB_MESSAGE"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent layout-w2 current" },
                                React.createElement(MassageMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_MENUMANAGEMENT /*"TAB_MENU"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent layout-w2 current" },
                                React.createElement(MenuMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_CHECKSHEETMANAGEMENT /*"TAB_CHECK"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent layout-w2 current" },
                                React.createElement(CheckSheetMain, { setPopWin: props.setPopWin })),
                        (curTabMenu.tabUrl === CONST.URL_ECONSULTMANAGEMENT /*"TAB_CHECK"*/) &&
                            React.createElement("div", { id: curTabMenu.id, className: "tabcontent current" },
                                React.createElement(EconsultMain, { setPopWin: props.setPopWin, handleNodata: handleNodata }))))))));
}
;
export default ManagementMain;
